// extracted by mini-css-extract-plugin
export default {"sectionLogin":"login_sectionLogin__rqwF8","loginContainer":"login_loginContainer__WXffL","loginForm":"login_loginForm__q6evl"};